import { EventEmitter } from './eventEmitter';
import { createDeck } from './utils';
export class BaseGame extends EventEmitter {
    constructor(numPlayers, deck = null) {
        super();
        this.playerCount = numPlayers;
        if (deck === null) {
            deck = createDeck();
        }
        this.gameState = BaseGame.createNewGameState();
        this.gameState.cards = deck;
    }
    static createNewGameState(roundNumber = 1, currentPlayer = 0) {
        return {
            currentPlayer: currentPlayer,
            cards: [],
            roundNumber: roundNumber,
            roundStage: '',
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZUdhbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZ2FtZS1saWIvYmFzZUdhbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBQzlDLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFFckMsTUFBTSxPQUFnQixRQUFTLFNBQVEsWUFBWTtJQUlsRCxZQUFZLFVBQWtCLEVBQUUsT0FBc0IsSUFBSTtRQUN6RCxLQUFLLEVBQUUsQ0FBQztRQUNSLElBQUksQ0FBQyxXQUFXLEdBQUcsVUFBVSxDQUFDO1FBQzlCLElBQUksSUFBSSxLQUFLLElBQUksRUFBRTtZQUNsQixJQUFJLEdBQUcsVUFBVSxFQUFFLENBQUM7U0FDcEI7UUFDRCxJQUFJLENBQUMsU0FBUyxHQUFHLFFBQVEsQ0FBQyxrQkFBa0IsRUFBRSxDQUFDO1FBQy9DLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQztJQUM3QixDQUFDO0lBSUQsTUFBTSxDQUFDLGtCQUFrQixDQUFDLFdBQVcsR0FBRyxDQUFDLEVBQUUsYUFBYSxHQUFHLENBQUM7UUFDM0QsT0FBTztZQUNOLGFBQWEsRUFBRSxhQUFhO1lBQzVCLEtBQUssRUFBRSxFQUFFO1lBQ1QsV0FBVyxFQUFFLFdBQVc7WUFDeEIsVUFBVSxFQUFFLEVBQUU7U0FDZCxDQUFDO0lBQ0gsQ0FBQztDQUVEIn0=